import APIClient from '@/shared/http/clients/api'

const resourceName = 'blocklist/whatsapp'
const APICore = process.env.APIBaseURLCore

const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/listBlockList?page=${index}&size=${limit}`, config)
const Search = (date = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?data=${date}&page=${index}&size=${limit}`, config)
const Delete = (id) => APIClient.delete(`${APICore}/${resourceName}/${id}`)

const BlockListRepository = {
  GetAllPaging,
  Search,
  Delete
}

export default BlockListRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/blocklist/blocklist.js